import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    places: [],
    allPlaces: [],
    filters: {
      order_by: 'short_name',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async addInternalPlace({ commit }, { payload }) {
      const company = await this.$axios.post(`${baseURLv1}/permit/place/`, payload);
      commit('add', ['places', company.data.data]);
    },

    async editPlace({ commit }, { place, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/permit/place/${id}/`, place);

      commit('update', ['places', { id, payload: response.data.data }]);
    },

    async getPlaceDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/place/${id}/`);

      return response.data.data;
    },

    async deletePlace({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/permit/place/${id}/`);

      commit('remove', ['places', id]);
      return response.data.data;
    },

    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/permit/place/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['places', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
    async loadAllPLaces({ _, commit }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/place/`, {
        params: {
          page: 1,
          page_size: 1000,
        },
      });

      commit('set', ['allPlaces', response.data.data]);
    },
  },
  getters: {
    selectOptions: (state) => state.allPlaces,
  },
};
